import API from "./api"

export default function useAddDealComparableDeals({ deal }) {
  return async (comparables) => {
    await API.post(`deals/${deal.id}/sales`, {
      comparable_id: comparables.map((comparable) => comparable.id),
    })
  }
}
